<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Reporte de Reclamos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Reclamos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.estadoBCRA"
              label="Estado BCRA"
              :items="listBCRA"
              item-text="key"
              item-value="value"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              label="Estado:"
              v-model="filtro.estadoId"
              :items="listEstados"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaDesde"
              label="Ingresados Desde"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaHasta"
              label="Ingresados Hasta"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-checkbox
              label="Filtrar por Fecha de Cierre"
              v-model="filtro.filtrarPorFechaCierre"
            ></v-checkbox>
            <app-selector-periodos
              v-if="filtro.filtrarPorFechaCierre"
              v-on:update-periodo="filtro.periodoCierre = $event"
            ></app-selector-periodos>
          </v-col>
        </v-row>

        <v-row dense> </v-row>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn> -->
        <v-spacer></v-spacer>
        <v-btn dark color="green" @click="procesarReporte">
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 0,
        estadoId: 0,
        estadoBCRA: 0,
        fechaDesde: null,
        fechaHasta: null,
        filtrarPorFechaCierre: false,
        periodoCierre: { id: 1 },
      },
      listEmpresas: [],
      listEstados: [],
      listBCRA: [
        { key: '(Todos)', value: 0 },
        { key: 'Abierto', value: 1 },
        { key: 'Cerrado', value: 2 },
      ],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadEstados();

    this.filtro.fechaDesde = this.$moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),

    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.listEmpresas = result.list;
        this.listEmpresas.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstados() {
      this.loading = true;
      try {
        var result = await http.get('reclamos/list/tipoaccionesreclamo');

        this.listEstados = result.list;

        this.listEstados.unshift({ id: 0, descripcion: '(Cualquiera)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      if (!this.filtro.fechaDesde) {
        this.alertWarning('Debe ingresar la Fecha de Ingreso Desde.');
        return false;
      }

      if (!this.filtro.fechaHasta) {
        this.alertWarning('Debe ingresar la Fecha de Ingreso Hasta.');
        return false;
      }

      return true;
    },
    async procesarReporte() {
      // validaciones
      //console.group("ProcesarReporte");
      //console.log(this.filtro.estadoBCRA.value);
      //console.groupEnd();
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          EmpresaId: this.filtro.empresaId,
          EstadoBCRA: this.filtro.estadoBCRA,
          AccionActualId: this.filtro.estadoId,
          AltaReclamoDesde: this.filtro.fechaDesde,
          AltaReclamoHasta: this.filtro.fechaHasta,
          CierreReclamoDesde: this.filtro.filtrarPorFechaCierre
            ? this.filtro.periodoCierre.desde
            : null,
          CierreReclamoHasta: this.filtro.filtrarPorFechaCierre
            ? this.filtro.periodoCierre.hasta
            : null,
        });

        this.setReporteActivo({
          reporte: 'Reporte Reclamos.trdp',
          params: params,
        });
        window.open('/report-viewer');
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
